if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/** Mobile navigation responds immediately; header measurements run once per frame. */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    connectedCallback() {
      if (this._headerConnected) return;
      this._headerConnected = true;
      this.header_section = this.closest('.header-section') || this;
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      this.summary = this.toggle && this.toggle.querySelector('.mobile-toggle');
      this._values = {};
      this._onToggle = (event) => {
        event.preventDefault();
        this.setMenuOpen(!this.toggle.open);
      };
      this._onEscape = (event) => {
        if (event.key === 'Escape' && this.toggle && this.toggle.open) {
          this.setMenuOpen(false);
          this.summary.focus();
        }
      };
      this._onMenuClick = (event) => {
        const back = event.target.closest('.parent-link-back--button');
        if (back && this.menu.contains(back)) {
          event.preventDefault();
          this.closeSubmenu(back.closest('details'));
          return;
        }
        const summary = event.target.closest('summary');
        if (summary && this.menu.contains(summary)) {
          const details = summary.parentElement;
          event.preventDefault();
          details.open = !details.open;
          details.classList.toggle('menu-opening', details.open);
          const parent = details.parentElement.closest('.link-container');
          if (parent) parent.classList.toggle('submenu-open', details.open);
        }
      };
      this._scheduleHeader = () => {
        if (this._headerFrame) return;
        this._headerFrame = requestAnimationFrame(() => {
          this._headerFrame = null;
          this.updateHeaderMetrics();
        });
      };
      if (this.summary && this.menu) {
        this.summary.addEventListener('click', this._onToggle);
        this.menu.addEventListener('click', this._onMenuClick);
        document.addEventListener('keyup', this._onEscape);
        // Honour a native click made before this asset finished downloading.
        if (this.toggle.open) this.setMenuOpen(true);
      }
      window.addEventListener('scroll', this._scheduleHeader, { passive: true });
      window.addEventListener('resize', this._scheduleHeader, { passive: true });
      if (window.ResizeObserver) {
        this._headerObserver = new ResizeObserver(this._scheduleHeader);
        this._headerObserver.observe(this);
        const announcement = document.getElementById('shopify-section-announcement-bar');
        if (announcement) this._headerObserver.observe(announcement);
      }
      this.updateHeaderMetrics();
    }
    disconnectedCallback() {
      if (!this._headerConnected) return;
      if (this.summary) this.summary.removeEventListener('click', this._onToggle);
      if (this.menu) this.menu.removeEventListener('click', this._onMenuClick);
      document.removeEventListener('keyup', this._onEscape);
      window.removeEventListener('scroll', this._scheduleHeader);
      window.removeEventListener('resize', this._scheduleHeader);
      if (this._headerObserver) this._headerObserver.disconnect();
      if (this._headerFrame) cancelAnimationFrame(this._headerFrame);
      this._headerFrame = null;
      if (this._ownsScrollLock) document.body.classList.remove('overflow-hidden');
      this._ownsScrollLock = false;
      this._headerConnected = false;
    }
    setMenuOpen(open) {
      this.toggle.open = open;
      this.toggle.classList.toggle('active', open);
      this.summary.setAttribute('aria-expanded', String(open));
      if (open) {
        if (!document.body.classList.contains('overflow-hidden')) {
          this._ownsScrollLock = true;
          document.body.classList.add('overflow-hidden');
        }
        this._scheduleHeader();
      } else if (this._ownsScrollLock) {
        document.body.classList.remove('overflow-hidden');
        this._ownsScrollLock = false;
      }
    }
    updateHeaderMetrics() {
      // Collect layout reads before writing classes or CSS variables.
      const top = this.header_section.getBoundingClientRect().top;
      const height = this.clientHeight;
      const ownTop = this.getBoundingClientRect().top;
      const scrollY = window.scrollY;
      const announcement = document.getElementById('shopify-section-announcement-bar');
      const announcementHeight = announcement ? announcement.clientHeight : 0;
      const sticky = scrollY > 0 && scrollY >= parseInt(ownTop, 10) + document.documentElement.scrollTop;
      if (this.classList.contains('header-sticky--active')) this.classList.toggle('is-sticky', sticky);
      this.setMetric('--header-offset', top);
      this.setMetric('--header-height', height);
      this.setMetric('--announcement-height', announcementHeight);
    }
    setMetric(name, value) {
      const text = value + 'px';
      if (this._values[name] === text) return;
      this._values[name] = text;
      document.documentElement.style.setProperty(name, text);
    }
    closeSubmenu(details) {
      if (!details) return;
      details.open = false;
      details.classList.remove('menu-opening', 'submenu-open');
      const parent = details.parentElement.closest('.link-container');
      if (parent) parent.classList.remove('submenu-open');
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}